<template>   
  <b-modal :id="id" size="md" centered header-bg-variant="primary" header-text-variant="light" 
  button-size="sm" ref="modal" @ok="saveItem" @hidden="resetModal" @show="resetModal"
  title="Novo Material Ou Serviço">
  <form ref="form" @submit.stop.prevent="handleSubmit" validated > 
          <BRow>
            <BCol sm=12>
              <BAlert class="mt-2" :show="messageShow" :variant="messageVariant" dismissible>
                <span>{{ messageText }}</span>
              </BAlert>
            </BCol>
          </BRow>
          <b-row>
          <b-col sm="12">
            <b-form-group 
                label-cols-sm="3" class="m-1" label-size="md"
                content-cols-sm="9"
                id="itemName"
                label="Nome do Material"
                label-class="font-weight-bold"
                label-for="itemNameInput"
                description=""
                invalid-feedback="Nome do Material é Obrigatório"
                :state="materialNameState"
              >
              
                <b-input-group prepend="">
                  <b-form-input
                        id="itemNameInput"
                        type="text"
                        placeholder="Nome Do Custo ou Serviço"
                        v-model="materialName"
                        :state="materialNameState"
                        required
                      />
                </b-input-group>
                <small>Se inserir um Material com um nome que já existe na lista, este item será atualizado.</small>
            </b-form-group>

            <b-form-group 
                label-cols-sm="3" class="m-1" label-size="md"
                content-cols-sm="9"
                id="itemCost"
                label="Preço Pago Por Metro Ou Quantidade"
                label-for="itemCostInput"
                label-class="font-weight-bold"
                invalid-feedback="Preço do Material é Obrigatório"              
                :state="priceState"          
              >
              
                <b-input-group class="m-1">
                  
                  <b-input-group-prepend is-text>
                      R$
                  </b-input-group-prepend> 
                  
                  <b-form-input
                        id="itemCostInput"
                        type="text"
                        placeholder="Digite o preço que pagou em uma unidade (ex.: Metro, Unidade, Peças) desse material."
                        v-model="price"
                        v-b-tooltip.hover 
                        title="Se comprou uma embalagem ou pacote clique na calculadora"
                        :state="priceState"
                        v-currency
                        required
                  />

                  <b-input-group-append >
                    <CalcButton @doCalc="value=>handleCalc(value)"/>  
                  </b-input-group-append>
                    
                </b-input-group>
            </b-form-group>

            <b-form-group 
                label-cols-sm="3" class="m-1" label-size="md"
                
                content-cols-sm="9"
                id="itemQtd"
                label="Rendimento do Material"
                label-for="itemQtdInput"
                label-class="font-weight-bold"
                invalid-feedback="Rendimento do Material é Obrigatório"
              >
                

                <b-input-group>
                  <b-form-input
                        id="itemQtdInput"
                        type="text"
                        placeholder="Rendimento do Material por Peça"  
                        :value="qtd"          
                        @input.native="formatNumber"    
                        :state="qtdState"
                        @change="validPrice"
                        required
                        v-b-tooltip.hover 
                        title="Quantos do material precisa para fazer 1 produto?"
                      />
                      
                </b-input-group>
            </b-form-group>

            <b-form-group 
                label-cols-sm="3" class="m-1" label-size="md"
                content-cols-sm="9"
                id="costByItem"
                label="Total do Material"
                label-for="costByItemInput"
                label-class="font-weight-bold"
              >
              
                <b-input-group prepend="R$">
                  <b-form-input
                        id="costByItemInput"
                        type="text"
                        placeholder="Custo por Peça"
                        required
                        disabled
                        v-currency
                        :value="costByItem"
                      />
                </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <BRow>
            <div v-if="deleteButton" class="d-flex justify-content-start m-2">
                <button class="btn btn-danger" @click="deleteItemById" >Apagar</button>
            </div>
        </BRow>
    </form>

    <template #modal-ok>
            Salvar
    </template>
    
    </b-modal>

</template>

<script>
import CalcButton from './CalcButton.vue';
import { formatDecimalPtBR } from '@/helpers';

export default {
    props:{
        id:{
            type:String,
            required:true
        },
        item: {
          type: Object,
          default() {
            return {}
          }
        }
    },
    data(){
      return {
            costId:0,
            materialName:"",
            price: "",
            qtd:'',
            message:"",
            materialNameState:null,
            priceState:null,
            qtdState: null,
            messageShow: 0,
            messageVariant: "warning",
            messageText:""
        }
  },
  watch: {
      item: {
        handler(costItem) {
          if (costItem) {
            this.costId = costItem.target.id
            this.materialName = costItem.target.costName            
            this.price = typeof costItem.target.price === "string" ?
            formatDecimalPtBR(parseFloat(costItem.target.price)) :
            formatDecimalPtBR(costItem.target.price)
            this.qtd = parseFloat(costItem.target.quantity).toFixed(2).replace('.',',')
            }
          },
          deep: true,
          immediate: true
      },
  },
  computed:{
    costByItem() {
      const price = parseFloat(this.price.replace(",",".")).toFixed(2)
      const qtd = parseFloat(this.qtd.replace(",", ".")).toFixed(2)

      // Math.round(price * qtd * 100) / 100: Multiplica o valor por 100, arredonda para o inteiro mais próximo e divide por 100 novamente. Isso elimina decimais além da 2ª casa.
      //minimumFractionDigits: 2: Exige pelo menos 2 casas decimais (ex: 5,20).
      //maximumFractionDigits: 2: Limita a no máximo 2 casas decimais (evita 5,200).
      return (price && qtd) > 0 ? (Math.round(price * qtd * 100) / 100).toLocaleString('pt-br', {minimumFractionDigits:2, maximumFractionDigits: 2 }) : 0
    },
    deleteButton() {
        if (this.item && this.item.target) {
          return true
        }
        return false
    },
  },
  methods: {
        handleCalc(value) {
          this.price = value.replace(".",",")
        },
        formatNumber(event) {
          // Obtém o valor digitado
        let value = event.target.value;

        // Remove qualquer caractere que não seja número
        let numericValue = value.replace(/\D/g, '');

        // Adiciona a vírgula antes dos dois últimos dígitos, se houver mais de dois dígitos
        if (numericValue.length > 2) {
          numericValue = value.replace(/\D/g, '').replace(/(\d)(?=(\d{2})$)/g, '$1,');
        } else if (numericValue.length === 2) {
          // Caso tenha exatamente 2 dígitos, insere o valor como "0,XX"
          numericValue = value.replace(/\D/g, '').replace(/(\d)(?=(\d{1})$)/g, '$1,');
        } 
        // Atualiza o valor do input
        this.qtd = numericValue;
        event.target.value = numericValue;
        },
        validPrice() {
          if (!this.price) {
            this.messageShow = 5;
            this.messageText = "Preço do Material não pode ser vazio";
            
            }      
        },         
        saveItem(bvModalEvent){
            bvModalEvent.preventDefault()
        // Trigger submit handler
            this.handleSubmit()
        },
        handleSubmit(){
            // Exit when the form isn't valid
            if (!this.checkFormValidity()) {
              return
            }
            // Push the name to submitted names
            
            this.$emit("newItem", {
              id: this.costId,
              costName: this.materialName,
              price: parseFloat(this.price.replace(',',".")),
              quantity: parseFloat(this.qtd.toString().replace(',',".")),
              costByItem: parseFloat(this.costByItem.replace(",","."))
            })
            
            // Hide the modal manually
            this.$nextTick(() => {
              this.$bvModal.hide(this.id)
            })
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.materialNameState = valid
            this.priceState= valid
            this.qtdState= valid
            return valid
        },
        resetModal() {
            this.materialName=""
            this.price=""
            this.qtd=""
            this.materialNameState=null
            this.priceState= null
            this.qtdState= null
        },
        deleteItemById() {
            const h = this.$createElement
          
            const msgHTML = h('div', {class:["text-center"],domProps:{innerHTML:`
                      <p>Tem Certeza que Deseja Apagar? <br/>
                      <br/> <small class="text-danger fw-bold fs-2">Essa Operação Não Pode Ser Desfeita!</small></p>`}})

          this.$bvModal.msgBoxConfirm(msgHTML, {
            title: "Apagar Material",
            size: "md",
            centered: true,
            okVariant: "danger",
            okTitle: "Apagar",
            cancelTitle: "Cancelar",
            headerBgVariant: "primary",
            headerTextVariant: "white"

          })
            .then(confirm => {
              if (confirm) {
                this.$emit("deleteDirectCost", this.costId )
              }
            });
        }
  },
  components: {CalcButton},

}
</script>

<style>


</style>